import { useEffect, useState } from 'react';
import ButtonComponent from 'components/design-system/Button/Button';
import Text from 'components/design-system/Text/Text';
import { Negocio } from './Negocio';

export const Resultados = ({
  dataNegocios,
  itemsToShow,
  handleShowMore,
  tipoNegocio,
  selectedNegocio,
  cargarEmpresas
}) => {
  const [totalNegocio, setTotalNegocio] = useState(0);
  const [totalResiduos, setTotalResiduos] = useState(0);

  useEffect(() => {
    if (selectedNegocio) {
      setTotalNegocio(1);
      setTotalResiduos(selectedNegocio.totalResiduos);
    } else {
      setTotalNegocio(dataNegocios?.length || 0);
      const totalSum = dataNegocios.reduce(
        (sum, negocio) => sum + (negocio.totalResiduos || 0),
        0
      );
      setTotalResiduos(totalSum);
    }
  }, [selectedNegocio, dataNegocios]);

  return (
    <div className={`mb-10`}>
      <div className="flex justify-between">
        <Text className="mb-2">
          <strong>{totalNegocio}</strong>{' '}
          {tipoNegocio === 'generador'
            ? totalNegocio === 1
              ? 'generador'
              : 'generadores'
            : null}
          {tipoNegocio === 'receptor'
            ? totalNegocio === 1
              ? 'receptor'
              : 'receptores'
            : null}
          {totalNegocio === 1 ? ' encontrado' : ' encontrados'}
        </Text>

        <Text className="mb-2">
          <strong>{totalResiduos}</strong>{' '}
          {tipoNegocio === 'generador'
            ? totalResiduos === 1
              ? 'residuo'
              : 'residuos'
            : null}
          {tipoNegocio === 'receptor'
            ? totalResiduos === 1
              ? 'residuo'
              : 'residuos'
            : null}
          {totalResiduos === 1 ? ' declarado' : ' declarados'}
        </Text>
      </div>

      {selectedNegocio ? (
        <Negocio
          key={selectedNegocio.value}
          negocio={selectedNegocio}
          tipoNegocio={tipoNegocio}
          cargarEmpresas={cargarEmpresas}
        />
      ) : (
        dataNegocios
          .sort((a, b) => b.totalResiduos - a.totalResiduos)
          .slice(0, itemsToShow)
          .map(negocio => (
            <Negocio
              key={negocio.value}
              negocio={negocio}
              tipoNegocio={tipoNegocio}
              cargarEmpresas={cargarEmpresas}
            />
          ))
      )}

      {itemsToShow < dataNegocios.length &&
        !selectedNegocio && ( // Mostrar el botón solo si hay más elementos y no se ha seleccionado un negocio
          <div className="text-center m-4">
            <ButtonComponent type="secondary" onClick={handleShowMore}>
              Ver más resultados
            </ButtonComponent>
          </div>
        )}
    </div>
  );
};
